import React, { useRef, useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { tinyMCEApiKey } from "src/helpers/AppConfig";

interface CustomEditorProps {
  onSubmit: (content: string) => void;
  initialValue: string | undefined;
}

const CustomEditor: React.FC<CustomEditorProps> = ({
  onSubmit,
  initialValue,
}) => {
  const editorRef = useRef<any>(null);
  const [isEditorReady, setIsEditorReady] = useState(false);
  const [value, setValue] = useState<string | undefined>(initialValue);

  useEffect(() => {
    if (!isEditorReady && initialValue) {
      setValue(initialValue);
    }
  }, [initialValue, isEditorReady]);

  const handleInit = (evt: any, editor: any) => {
    editorRef.current = editor;
    setIsEditorReady(true);
    if (initialValue) {
      editor.setContent(initialValue);
    }
  };

  const handleEditorChange = () => {
    setValue(editorRef.current.getContent());
  };

  const handleEditorBlur = () => {
    onSubmit(editorRef.current.getContent());
  };

  return (
    <Editor
      onChange={handleEditorChange}
      onBlur={handleEditorBlur}
      onInit={handleInit}
      initialValue={initialValue}
      apiKey={tinyMCEApiKey}
      init={{
        height: 400,
        menubar: true,
        plugins:
          "powerpaste casechange searchreplace autolink directionality advcode visualblocks visualchars image link codesample table charmap pagebreak nonbreaking anchor tableofcontents advlist lists checklist wordcount editimage formatpainter permanentpen charmap linkchecker emoticons advtable",
        toolbar:
          "undo redo | blocks fontfamily fontsize | bold italic underline forecolor backcolor | link addcomment showcomments  | alignleft aligncenter alignright alignjustify lineheight | checklist bullist numlist indent outdent | removeformat",
        toolbar_sticky: true,
        autosave_ask_before_unload: false,
        autosave_interval: "0s",
        images_upload_url: "",
        browser_print:false,
        browser_spellcheck: false,
        contextmenu: false,
        icons: "thin",
        skin: "material-classic",
        content_style: "material-classic",
      }}
    />
  );
};

export default CustomEditor;
